// extracted by mini-css-extract-plugin
export default {"container":"BackButton_container__Sj-SQ","arrowIcon":"BackButton_arrowIcon__NCoiJ","label":"BackButton_label__iePhJ"};